/** localStorage for EVO trial-reason question (/switch-reason). */
export const SWITCH_REASON_STORAGE_KEY = 'ploomsurvey:switchReason';

export type SwitchReasonAnswer =
  | 'reduce_tar'
  | 'taste'
  | 'value'
  | 'feels_right'
  | 'friend_reco';

export type SwitchReasonAnswers = {
  reason: SwitchReasonAnswer;
};

export function readSwitchReasonAnswers(): SwitchReasonAnswers | null {
  try {
    const raw = localStorage.getItem(SWITCH_REASON_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const r = (o as { reason?: unknown }).reason;
    if (
      r === 'reduce_tar' ||
      r === 'taste' ||
      r === 'value' ||
      r === 'feels_right' ||
      r === 'friend_reco'
    ) {
      return { reason: r };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeSwitchReasonAnswers(data: SwitchReasonAnswers): void {
  try {
    localStorage.setItem(SWITCH_REASON_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearSwitchReasonAnswers(): void {
  try {
    localStorage.removeItem(SWITCH_REASON_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isSwitchReasonComplete(): boolean {
  return readSwitchReasonAnswers() != null;
}
